/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../clients/axios.ts";
import type { RequestConfig, ResponseErrorConfig } from "../../../clients/axios.ts";
import type { GetApiDonationsByUserQueryResponse, GetApiDonationsByUserQueryParams, GetApiDonationsByUser400, GetApiDonationsByUser401, GetApiDonationsByUser403, GetApiDonationsByUser500 } from "../../types/GetApiDonationsByUser.ts";
import { getApiDonationsByUserQueryResponseSchema } from "../../zod/AdminPaymentsSchemas/getApiDonationsByUserSchema.ts";

function getGetApiDonationsByUserUrl() {
  const res = { method: 'GET', url: `/api/donations/by-user` as const }  
  return res
}

/**
 * @summary Получить список платежей по пользователям
 * {@link /api/donations/by-user}
 */
export async function getApiDonationsByUser({ params }: { params?: GetApiDonationsByUserQueryParams }, config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<GetApiDonationsByUserQueryResponse, ResponseErrorConfig<GetApiDonationsByUser400 | GetApiDonationsByUser401 | GetApiDonationsByUser403 | GetApiDonationsByUser500>, unknown>({ method : "GET", url : getGetApiDonationsByUserUrl().url.toString(), params, ... requestConfig })  
  return getApiDonationsByUserQueryResponseSchema.parse(res.data)
}